import { COLORS } from '@btime/constants'
import { propEq, and } from 'ramda'
import React, { useMemo } from 'react'

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../components/pdf/TableHelpers'
import Text from '../../../../components/pdf/Text'
import Image from '../../../../components/pdf/Image'
import Separator from '../../../../components/pdf/Separator'
import { formatPercentNumber, getConclusion } from '../_helpers/pdfHelpers'

const PointsTableWithImage = ({ image, sections, title, furnitureType, sector, type }) => {
  const sectionsSize = sections.length
  const allRows = sections.reduce((rows, section) => [...rows, ...section.rows], [])
  const rowsSize = allRows.length

  const truePoints = allRows.filter(row => {
    return row.value === true && !row.ignoreCount
  }).length
  const falsePoints = allRows.filter(row => {
    return row.value === false && !row.ignoreCount
  }).length
  const nullPoints = allRows.filter(row => {
    return row.value === null && !row.ignoreCount
  }).length

  const truePercentage = formatPercentNumber((truePoints / (truePoints + falsePoints)) * 100)

  const resume = useMemo(() => {
    return getConclusion(truePercentage, type)
  }, [truePercentage, type])

  const showResume2 = useMemo(() => {
    const found = allRows.find(row => {
      if (
        row.label === 'B.5 Cadeira possui braços?' ||
        row.label === 'B.6 Os braços das cadeiras são de altura regulável?' ||
        row.label === 'B.7 Os braços das cadeiras possuem regulagem fácil?'
      ) {
        return row.value === false
      } else {
        return false
      }
    })
    return !!found
  }, [allRows])

  return (
    <>
      <Table width="100%">
        <TableRow>
          {sector && (
            <TableColText bold align="center" size="small">
              {sector}
            </TableColText>
          )}
          {furnitureType && (
            <TableColText bold align="center" size="small" colSpan={4}>
              {furnitureType}
            </TableColText>
          )}
        </TableRow>

        {sections.map((section, sectionIndex) => (
          <>
            <TableRow key={sectionIndex}>
              {sectionIndex === 0 && (
                <TableHeadText width="220px" align="center">
                  {title}
                </TableHeadText>
              )}
              <TableHeadText>{section.label}</TableHeadText>
              <TableHeadText align="center">Sim</TableHeadText>
              <TableHeadText align="center">Não</TableHeadText>
              <TableHeadText align="center">N/A</TableHeadText>
            </TableRow>

            {section.rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {sectionIndex === 0 && rowIndex === 0 && (
                  <TableCol rowSpan={sectionsSize + rowsSize - 1}>
                    <Image src={image} ignoreFixedSize />
                  </TableCol>
                )}
                <TableColText>{row.label}</TableColText>
                <TableColText align="center">{row.value === true ? 'X' : ''}</TableColText>
                <TableColText align="center">{row.value === false ? 'X' : ''}</TableColText>
                <TableColText align="center">{row.value === null ? 'X' : ''}</TableColText>
              </TableRow>
            ))}
          </>
        ))}

        <TableRow>
          <TableHeadText>Classificação de Adequação</TableHeadText>
          <TableHeadText align="right" rowSpan={3}>
            Soma dos pontos:
          </TableHeadText>
          <TableHeadText align="center" rowSpan={3} bgColor={COLORS.lightGreen}>
            {truePoints}
          </TableHeadText>
          <TableHeadText align="center" rowSpan={3} bgColor={COLORS.red}>
            {falsePoints}
          </TableHeadText>
          <TableHeadText align="center" rowSpan={3}>
            {nullPoints}
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.lightGreen}>91 a 100% dos pontos - condição ergonômica excelente</TableColText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.lightGreen}>71 a 90% dos pontos - condição ergonômica boa</TableColText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.yellow}>51 a 70% dos pontos - condição ergonômica razoável</TableColText>
          <TableHeadText align="right" rowSpan={4}>
            Classificação de adequação (%):
          </TableHeadText>
          <TableHeadText align="center" rowSpan={4} colSpan={3} bgColor={COLORS.lightGreen}>
            {truePercentage}%
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.red}>31 a 50% dos pontos - condição ergonômica ruim</TableColText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.red}>Inferior a 31% - condição ergonômica péssima</TableColText>
        </TableRow>
      </Table>

      {resume && (
        <>
          <Text bold size="small">
            CONCLUSÃO / AÇÃO DE ERGONOMIA
          </Text>
          <ul style={{ marginTop: '0rem' }}>
            <li>
              <Text>{resume}</Text>
            </li>
            {showResume2 && (
              <li>
                <Text>
                  Os itens considerados como boas práticas, não são de exigência legal previstos no iten 17.6.6, sendo
                  monitorados com o objetivo de mapear as características dimensionais que possibilitem posicionamento e
                  movimentação dos segmentos corporais de forma a não comprometer a saúde e não ocasionar amplitudes
                  articulares excessivas ou posturas nocivas de trabalho.
                </Text>
              </li>
            )}
          </ul>
        </>
      )}
      <Separator weight={8} />
    </>
  )
}

export default PointsTableWithImage
